<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="ion-text-left" slot="start" (click)="onDismiss()">
      <ion-button >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Select Discount
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf="isDiscountListLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingDiscounts" (click)="tapToRetry()"></salonmonster-tap-retry>

  <ion-list>
    <ion-item-group>
      <ion-item-divider color="light"><b>My Discounts</b>
        <ion-button 
          
          fill="clear"
          slot="end"
          (click)="onAddMyDiscount()">
          <ion-icon name="add"></ion-icon>
        </ion-button>
      </ion-item-divider>

      <ion-item 
        *ngFor="let discount of myDiscounts"
        
        (click)="onDiscountTap(discount)">
          {{ discount | discountLabel }}
        <ion-icon
          *ngIf="discount.id == selectedDiscountID"
          name="checkmark" 
          item-right></ion-icon>
      </ion-item>
    </ion-item-group>

    <ion-item-group>
      <ion-item-divider color="light"><b>Salon Discounts</b>
        <ion-button 
          
          fill="clear"
          slot="end"
          (click)="onAddSalonDiscount()">
          <ion-icon name="add"></ion-icon>
        </ion-button>
      </ion-item-divider>

      <ion-item 
        *ngFor="let discount of salonDiscounts"
        (click)="onDiscountTap(discount)">
          {{ discount | discountLabel }}
        <ion-icon
          *ngIf="discount.id == selectedDiscountID"
          name="checkmark" 
          item-right></ion-icon>
      </ion-item>
    </ion-item-group>

  </ion-list>

</ion-content>
